import React from "react";
import { Edit, Trash2 } from "lucide-react";
import Modal from "react-responsive-modal";
import { useDynamicResolution } from "../../../../hooks/useDynamicResolution";
import Button from "../../../../components/Button/Button";
import { FormModalProps } from "../interfaces";
import ToolTip from "../../../ToolTip/ToolTip";

export const FormModal: React.FC<FormModalProps> = (props) => {
  const {
    children,
    createItem,
    customActions,
    deleteItem,
    formStatus,
    hasDelete = true,
    isFormValid = true,
    isLoading,
    modalHeightClass,
    modalWidthClass,
    onClose,
    setFormStatus,
    title,
    updateItem,
  } = props;
  const isDesktop: boolean = useDynamicResolution(1280);

  return (
    <Modal
      open={formStatus !== "hidden"}
      classNames={{
        modal: `bg-white w-full shadow-xl !p-0 !m-0 h-full rounded-none sm:rounded-2xl ${
          window.innerHeight > 900
            ? modalHeightClass || "sm:h-[81vh]"
            : "sm:h-[95vh]"
        } ${modalWidthClass || "sm:w-[600px] md:w-[700px] lg:w-[800px]"}`,
        overlay: "bg-modal-overlay",
      }}
      onClose={onClose}
      blockScroll={isDesktop}
      center
      showCloseIcon={false}
      focusTrapped={false}
    >
      <div className="flex h-full flex-col bg-white">
        <div className="flex flex-wrap items-center justify-between gap-4 p-6">
          <h1 className="text-lg font-semibold">{title}</h1>
          {(formStatus === "detail" ||
            formStatus === "edit" ||
            formStatus === "delete") && (
            <div className="ml-auto flex flex-wrap gap-2">
              {customActions}
              {hasDelete && (
                <ToolTip
                  text="Eliminar"
                  placement="bottom"
                >
                  <button
                    className={`flex h-10 w-10 items-center justify-center gap-2 rounded-md border border-gray-200 px-4 py-2 transition-colors duration-300 ${
                      formStatus === "delete"
                        ? "bg-red-50 text-red-500"
                        : "text-red-500 hover:bg-red-50 hover:text-red-700"
                    }`}
                    disabled={isLoading}
                    onClick={() =>
                      setFormStatus(
                        formStatus === "delete" ? "detail" : "delete",
                      )
                    }
                  >
                    <Trash2 className="h-4 w-4 shrink-0" />
                  </button>
                </ToolTip>
              )}
              {updateItem && (
                <ToolTip
                  text="Editar"
                  placement="bottom"
                >
                  <button
                    className={`flex h-10 w-10 items-center justify-center gap-2 rounded-md border border-gray-200 px-4 py-2 transition-colors duration-300 ${
                      formStatus === "edit"
                        ? "bg-gray-100 text-gray-900"
                        : "text-gray-500 hover:bg-gray-100 hover:text-gray-900"
                    }`}
                    disabled={isLoading}
                    onClick={() =>
                      setFormStatus(formStatus === "edit" ? "detail" : "edit")
                    }
                  >
                    <Edit className="h-4 w-4 shrink-0" />
                  </button>
                </ToolTip>
              )}
            </div>
          )}
        </div>
        <div className="overflow-y-auto px-6">{children}</div>
        <div className="mt-auto flex flex-col justify-end gap-4 p-6 sm:flex-row">
          <Button
            type="secondary"
            className="w-full sm:w-auto"
            label="Cancelar"
            onClick={onClose}
          />
          <Button
            type={formStatus === "delete" ? "danger" : "tertiary"}
            className="w-full sm:w-auto"
            loading={isLoading}
            disabled={
              isLoading ||
              (!isFormValid && formStatus !== "delete") ||
              formStatus === "detail" ||
              formStatus === "hidden"
            }
            label={formStatus === "delete" ? "Eliminar" : "Guardar"}
            onClick={
              formStatus === "create"
                ? createItem
                : formStatus === "edit"
                  ? updateItem
                  : deleteItem
            }
          />
        </div>
      </div>
    </Modal>
  );
};
